import { createContext } from 'react';
export const ForgotPasswordContext = createContext(null);
